import { render, staticRenderFns } from "./Delta.vue?vue&type=template&id=2458cb22&scoped=true&"
import script from "./Delta.vue?vue&type=script&lang=ts&"
export * from "./Delta.vue?vue&type=script&lang=ts&"
import style0 from "./Delta.vue?vue&type=style&index=0&id=2458cb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458cb22",
  null
  
)

export default component.exports